<template>
  <div class="w-full">
    <label :for="id" class="sr-only">Verification code</label>
    <input ref="input" :id="id" name="one-time-code" type="text" inputmode="numeric" autocomplete="one-time-code"
      :value="modelValue" @input="onInput" :disabled="disabled"
      class="w-full h-12 text-center text-2xl font-semibold tracking-[0.4em] tabular-nums" :class="{ 'input-not-validated': invalid }"
      :aria-invalid="invalid || null" :aria-describedby="describedby">
  </div>
</template>

<script>
import { ref } from 'vue'

// The one 6-digit code box: keeps digits only (pasted spaces and dashes drop out) and reports `complete` at 6.
// No maxlength: the browser would cut a pasted "123 456" to "123 45" before the digits are kept.
export default {
  name: 'CodeInput',
  props: {
    modelValue: { type: String, default: '' },
    id: { type: String, required: true },
    invalid: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    describedby: { type: String, default: null }
  },
  emits: ['update:modelValue', 'complete'],
  setup(props, { emit, expose }) {

  // Refs
    const input = ref(null)

  // Handlers
    const onInput = (e) => {
      const digits = (e.target.value || '').replace(/\D/g, '').slice(0, 6)
      const changed = digits !== props.modelValue
      e.target.value = digits
      emit('update:modelValue', digits)
      // Only a new 6-digit value submits: a key that leaves the same (wrong) code must not use up another try.
      if (digits.length === 6 && changed) { emit('complete', digits) }
    }

    expose({
      focus: () => input.value?.focus(),
      select: () => input.value?.select()
    })

    return { input, onInput }
  }
}
</script>
